.container {
  flex: 1;
}

.title {
  display: flex;
}

.formControl {
  width: 100%;
}

.option {
  width: 100%;
}
